export default __webpack_public_path__ + "static/media/product-11.e1d344d6.jpg";